var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "statistics" },
    [
      !_vm.searchBtn
        ? _c("oaFromBox", {
            attrs: {
              isAddBtn: false,
              isTotal: false,
              isViewSearch: false,
              search: _vm.isMine ? _vm.search : _vm.search2,
              sortSearch: false,
              total: _vm.total,
            },
            on: { confirmData: _vm.confirmData },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "statistics-con" }, [
        _c("div", { style: _vm.styles1, attrs: { id: "statistics-con" } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }